"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.popoverConfig = exports.intialValuesConfig = exports.initialTouchedConfig = exports.idPrefix = exports.dropdownOptions = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _utils = require("../../middleware/utils");
var _DefaultValues = require("./DefaultValues");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'college';
var idPrefix = exports.idPrefix = 'cs_';
var dropdownOptions = exports.dropdownOptions = {
  collegeTermArray: ['public 2-year', 'public 4-year in-state', 'public 4-year out-of-state', 'private 4-year'],
  numOfKidsArray: ['1', '2', '3', '4', '5', '6']
};
var popoverConfig = exports.popoverConfig = {
  inflationRate: "The <a href='https://trends.collegeboard.org/college-pricing/figures-tables/average-published-undergraduate-charges-sector-2016-17' target='_blank'>College Board</a> provides detailed information by type of College; this calculator uses a 5% estimate.",
  rateReturn: "Represents the assumed rate of return on your savings.",
  collegeTerm: "The <a href='https://research.collegeboard.org/trends/college-pricing' target='_blank'>College Board</a> provides detailed information by type of college."
};
var propsConfig = exports.propsConfig = {
  config: {
    API_URL: 'https://www-qa.massmutual.com/ict/calculate/collegeSavings_v0.1.2',
    Steps: [{
      Title: 'How much do I need to save for college?',
      Description: '',
      SecondaryDescription: "It's never too early to start saving for college. Our College Savings Calculator can help you estimate how much to save for college tuition, fees, room, and board.",
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Calculate',
        Icon: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Your Results',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next Steps',
        Description: 'Discuss your results with a financial professional today',
        CTAList: [{
          Label: 'Get Started',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: 'link'
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: 'link'
        }]
      }
    }]
  }
};
var validationConfigPage1 = yup.object().shape({
  numOfKids: yup.string().required('Must be between 1-6 children').min(1, 'Must be between 1-6 children').max(6, 'Must be between 1-6 children').oneOf(dropdownOptions.numOfKidsArray),
  collegeTerm: yup.string().required('Must provide a college term length').oneOf(dropdownOptions.collegeTermArray),
  children: yup.array().of(yup.object().shape({
    childAge: yup.number().transform(_utils.parseCurrencyString).required('Must be between 0-30 years old').min(0, 'Must be between 0-30 years old').max(30, 'Must be between 0-30 years old')
  })),
  contributionPercent: yup.number().transform(parseFloat).required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places'),
  savings: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $1,000,000').min(0, 'Must be between $0 and $1,000,000').max(1000000, 'Must be between $0 and $1,000,000')
});
var validationConfigPage2Additions = yup.object().shape({
  children: yup.array().of(yup.object().shape({
    childAge: yup.number().transform(_utils.parseCurrencyString).required('Must be between 0-30 years old').min(0, 'Must be between 0-30 years old').max(30, 'Must be between 0-30 years old'),
    collegeAge: yup.number().transform(_utils.parseCurrencyString).required('Must be between 0-31 years old').max(31, 'Must be between 0-31 years old'),
    fundPercent: yup.number().transform(parseFloat).required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places'),
    collegeTerm: yup.string().required('Must provide a college term length').oneOf(dropdownOptions.collegeTermArray)
  }).test((info, meta) => {
    var collegeAgeBiggerThanChildAge = info.collegeAge > info.childAge;
    return collegeAgeBiggerThanChildAge ? true : meta.createError({
      path: "".concat(meta.path, "collegeAge"),
      message: 'College Age must be greater than Child Age'
    });
  })),
  savings: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  rateReturn: yup.number().transform(parseFloat).required('Must be between 0% and 15% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 15% and to a maximum of 2 decimal places').max(15, 'Must be between 0% and 15% and to a maximum of 2 decimal places'),
  collegeInflation: yup.number().transform(parseFloat).required('Must be between 0% and 10% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 10% and to a maximum of 2 decimal places').max(10, 'Must be between 0% and 10% and to a maximum of 2 decimal places')
});
var validationConfig = exports.validationConfig = [validationConfigPage1, validationConfigPage2Additions];
var intialValuesConfig = exports.intialValuesConfig = {
  numOfKids: '1',
  collegeTerm: _DefaultValues.defaultValues.collegeTerm,
  contributionPercent: _DefaultValues.defaultValues.contributionPercent,
  savings: '',
  children: [{
    childAge: '',
    collegeAge: _DefaultValues.defaultValues.collegeAge1
  }],
  collegeInflation: _DefaultValues.defaultValues.collegeInflation,
  rateReturn: _DefaultValues.defaultValues.rateReturn,
  startIn: _DefaultValues.defaultValues.startIn
};
var initialTouchedConfig = exports.initialTouchedConfig = {};